import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { filter, mergeMap } from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { Epic } from "../utils/types";

// epics

const onRedirectToURL: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(isOfAction(actionCreators.redirectToUrl)),
        mergeMap(({ payload: { url } }) => {
            window.location.href = url;
            return of();
        })
    );

export const routerEpic = combineEpics(onRedirectToURL);
